import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property, state } from 'lit/decorators.js'
import { FILTER_WIZARD_STORE, FilterWizardStore } from 'components/discovery/filter-wizard/filter-wizard-store.js'
import { style } from './filter-header.style.js'
import { FilterHeaderDisplayOptions, FilterWizardConfig } from 'components/discovery/filter-wizard/typing/config.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { createEffect } from '@cloudsuite/mosaic-shared/scripts/signals.js'


@customElement('csc-filter-header')
export class CSCFilterHeader extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @inject(FILTER_WIZARD_STORE)
  private filterWizardStore!: FilterWizardStore

  @state()
  filterWizardConfig!: FilterWizardConfig

  @property({ attribute: 'filter-wizard-title' })
  private filterWizardTitle!: string

  @property({ type: Object, attribute: 'display-options' })
  displayOptions: FilterHeaderDisplayOptions | null = null

  constructor() {
    super()

    createEffect(() => {
      this.filterWizardConfig = this.filterWizardStore.filterWizardConfig()
    })
  }

  protected override render(): unknown {
    return html`
      <cse-text variant="${this.displayOptions?.titleVariant ?? 'heading-1'}" class="filter-wizard-title">
        ${this.filterWizardTitle}
      </cse-text>

      <cse-text variant="${this.displayOptions?.nameVariant ?? 'heading-2'}" class="filter-wizard-name">
        ${this.filterWizardConfig.name}
      </cse-text>

      <cse-text class="filter-wizard-description">
        ${this.filterWizardConfig.description}
      </cse-text>
    `
  }
}
